import { postMeetup as en_postMeetup } from "../en/post-meetup";

/** post-meetup — RU slice (31 keys). */
export const postMeetup: Record<keyof typeof en_postMeetup, string> = {
  post_meetup_prompt_title: "Как прошла встреча с {name}?",
  post_meetup_prompt_subtitle:
    "Хочешь обменяться контактами? Если вы оба согласитесь, вы поделитесь своими карточками Linqx.",
  post_meetup_prompt_disclaimer:
    "«Не сейчас» = отказ. Твой выбор останется в тайне.",
  post_meetup_match_button: "Мэтч",
  post_meetup_not_now_button: "Не сейчас",
  post_meetup_waiting_title: "Ждём ответа от {name}...",
  post_meetup_waiting_subtitle: "Твой выбор: Мэтч",
  post_meetup_waiting_notify: "Мы сообщим тебе, как только будет результат",
  post_meetup_withdraw_button: "Отменить",
  post_meetup_done_button: "Готово",
  post_meetup_connected_title: "Теперь вы на связи!",
  post_meetup_connected_subtitle:
    "Теперь ты можешь посмотреть карточку Linqx {name}.",
  post_meetup_linqx_card_button: "Карточка Linqx",
  post_meetup_no_vibe_title: "С {name} не срослось",
  post_meetup_no_vibe_subtitle: "Свайпай, чтобы найти кого-то ещё!",
  post_meetup_explore_button: "Смотреть",
  post_meetup_expired_title: "Твой мэтч с {name} истёк",
  post_meetup_expired_subtitle: "Ты всё ещё можешь сделать ремэтч из чата.",
  post_meetup_go_to_chat_button: "Перейти в чат",
  post_meetup_rematch_button: "Ремэтч",
  post_meetup_rematch_waiting_title: "Ждём ремэтч от {name}...",
  post_meetup_rematch_waiting_subtitle:
    "Ты нажал(а) «Ремэтч». Если {name} тоже сделает ремэтч, ваша связь восстановится.",
  post_meetup_chat_expired_message: "Этот мэтч истёк.",
  post_meetup_chat_expired_subtitle:
    "Чтобы продолжить общение, обоим нужно сделать ремэтч.",
  post_meetup_remaining: "Осталось {time}",
  post_meetup_confirm_title: "Ты встретил(а) {name} на {event}?",
  post_meetup_confirm_yes: "Да, встретились",
  post_meetup_confirm_not_yet: "Ещё нет",
  post_meetup_confirm_did_not_meet: "Мы не встретились",
  post_meetup_pending_title: "ЖДУТ ТВОЕГО ОТВЕТА ({count})",
  post_meetup_pending_respond: "Ответить",
};
